import React from "react";
import RegisterLayout from "./RegisterLayout";
import { PERMISSION_TYPE } from "../../../types";

interface StepDownloadAppProps {
    onNext: (data: any) => void;
}

const StepDownloadApp: React.FC<StepDownloadAppProps> = ({ onNext }) => {
    return (
        <RegisterLayout contentStyle={{ paddingBottom: 0 }} hideHeader>
            <div className="register-step">
                {/* Heading block */}
                <div className="register-step__heading-block">
                    <h1 className="register-step__title">
                        Download<br />our app
                    </h1>
                    <p className="register-step__description">
                        Log in to our mobile app with the account you just created, manage
                        your availability, find suppliers, locations, and apply for and
                        create jobs. All on the go, all on Sixth Degree.
                    </p>
                </div>

                {/* Finish button */}
                <div className="download-app__finish-row">
                    <button className="btn-next btn-next--yellow" onClick={() => onNext({ account_completed: true, permission_type: PERMISSION_TYPE.TYPE_CREW_MEMBER })}>
                        Finish
                    </button>
                </div>

                {/* Store links + app screenshot */}
                <div className="download-app__content">

                    {/* Left col: QR code + store badges */}
                    <div className="download-app__store-col">

                        <img
                            src="/assets/images/qr-code.svg"
                            alt="Scan to download"
                            className="download-app__qr"
                        />

                        {/* Google Play badge */}
                        <a
                            href="https://play.google.com/store/apps/details?id=io.sixthdegree.mobile.apps&pli=1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-app__store-badge"
                        >
                            <svg className="download-app__store-icon" viewBox="0 0 24 24">
                                <path d="M3.18 23.76c.4.22.87.24 1.3.06L16.31 12 4.48.18C4.05.01 3.58.03 3.18.24 2.46.64 2 1.4 2 2.28v19.44c0 .88.46 1.64 1.18 2.04z" fill="#EA4335" />
                                <path d="M21.18 10.64l-3.3-1.9L14.31 12l3.57 3.26 3.3-1.9c.94-.54.94-2.18 0-2.72z" fill="#FBBC04" />
                                <path d="M4.48 23.82l11.83-11.83L12.74 8.4 4.48.18v23.64z" fill="#34A853" />
                                <path d="M4.48.18l8.26 8.22 3.57-3.26L4.48.18z" fill="#4285F4" />
                            </svg>
                            <div className="download-app__store-text">
                                <span className="download-app__store-label">GET IT ON</span>
                                <span className="download-app__store-name">Google Play</span>
                            </div>
                        </a>

                        {/* App Store badge */}
                        <a
                            href="https://apps.apple.com/us/app/sixth-degree/id1661092945"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-app__store-badge"
                        >
                            <svg className="download-app__store-icon" viewBox="0 0 24 24" fill="white">
                                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                            </svg>
                            <div className="download-app__store-text">
                                <span className="download-app__store-label">Download on the</span>
                                <span className="download-app__store-name">App Store</span>
                            </div>
                        </a>

                    </div>

                    {/* Right col: app screenshot image */}
                    <div className="download-app__screenshot-col">
                        <img
                            src='/assets/images/app_banner.svg'
                            alt="App screenshot"
                            className="download-app__screenshot"
                        />
                    </div>

                </div>
            </div>
        </RegisterLayout>
    );
};

export default StepDownloadApp;